<div class="w-100" [chart]="chart"></div>
